module.exports = __webpack_public_path__ + "static/media/logo.2d1cc37b.svg";